import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { PaperComponent } from "../../../utils/helper";
import TextFieldWithToolTip from "../TextFieldWithToolTip/TextFieldWithToolTip";

export default function ConfirmDialog({
	IsOpen,
	Message,
	OnHandelClick,
	AgreeText = "Agree",
	DisAgreeText = "Disagree",
	deleteConfig = undefined,
	size = "xs"
}) {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down(size || "xs"));

	return (
		<div>
			<Dialog
				fullScreen={fullScreen}
				open={IsOpen}
				onClose={() => OnHandelClick(false)}
				aria-labelledby={"responsive-dialog-title"}
				PaperComponent={PaperComponent}
			>
				<DialogTitle
					style={{ cursor: "move" }}
					id={"responsive-dialog-title"}
					className={"center-title"}
				>
					{"Confirm\r"}
				</DialogTitle>
				<DialogContent>
					{deleteConfig && deleteConfig.isDeleteReason === true ? (
						<DialogContentText color={"primary"}>
							<div className={"col-xs-12"}>
								<p>{Message}</p>
							</div>
							<div className={"col-xs-12 delete-popup"}>
								<TextFieldWithToolTip
									id={deleteConfig.id}
									txtName={deleteConfig.id}
									isRequired
									labelHeading={deleteConfig.name}
									value={deleteConfig.value || ""}
									onChange={deleteConfig.action}
									inProps
								/>
							</div>
						</DialogContentText>
					) : (
						<DialogContentText color={"primary"}>{Message}</DialogContentText>
					)}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							OnHandelClick(true);
						}}
						color={"primary"}
						autoFocus
					>
						{AgreeText}
					</Button>
					<Button
						autoFocus
						onClick={() => OnHandelClick(false)}
						color={"primary"}
					>
						{DisAgreeText}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
